import React from "react";
import { Container, Body, ButtonContainer } from "./styles";
import { GrFormClose } from "react-icons/gr";

const ConfirmDelete = ({ closeModal, deleteObject, copyModal }) => {
  return (
    <Container>
      <div className="header">
        <h3>Excluir {copyModal}</h3>
        <button onClick={closeModal}>
          <GrFormClose size={22} />
        </button>
      </div>

      <Body>
        <h2>Deseja realmente excluir esse(a) {copyModal}?</h2>
        <ButtonContainer>
          <button onClick={closeModal}>Não</button>
          <button
            onClick={() => {
              deleteObject();
              closeModal();
            }}
          >
            Sim
          </button>
        </ButtonContainer>
      </Body>
    </Container>
  );
};

export default ConfirmDelete;
